import { ITableFiltersObject } from "@monorepo/utils/src/store/types/tableFiltersObject";
import { formDateFilter } from "@monorepo/utils/src/api/convertFiltersToApi";

export const convertFiltersCustomToApi = (resultFilters: ITableFiltersObject): void => {
  formDateFilter(resultFilters, "creationDate");
  formDateFilter(resultFilters, "expiredAt");
};
